(function($, d, w) {

	$(w).on(w.ZP_READY, onInit).on(w.ZP_LOAD, onLoad);

	function onInit()  {
		var elements = $('.zp_news_slider');
		if(elements.length > 0) {
			elements.each(function(index, element){
				var $ele = $(element);

				var $nav = $ele.find(".nav")
				var navCount = $ele.find('.article').length;
				var i = 0;
				while(i < navCount) {
					$nav.append('<li class="bullet-' + i + ' bullet"></li>');
					i = i + 1;
				}
				var $navButtons = $nav.find(".bullet");

				$ele.flickity({
					cellSelector: '.article',
					wrapAround: true,
					pauseAutoPlayOnHover: false,
					percentPosition: true,
					pageDots: false,
					accessibility: false,
					prevNextButtons: false,
					asNavFor : $nav.get(0),
					cellAlign: 'left',
					adaptiveHeight: false,
				});

				var slider = $ele.data('flickity');
				$ele.on('select.flickity', {"buttons" : $navButtons, "slider" : slider}, onSliderChange);
				$navButtons.on('click', {"slider" : $ele}, onSliderButtonClick);
				$($navButtons.get(0)).click();
			});
		}
	}

	function onLoad() {
		var elements = $('.zp_news_slider');
		if(elements.length > 0) {
			elements.each(function(index, element){
				var $ele = $(element);
				$ele.flickity('resize');
			});
		}
	}

	function onSliderChange(e) {
		var $navButtons = e.data.buttons;
		var slider = e.data.slider;
		$navButtons.filter('.is-selected').removeClass('is-selected');
		$navButtons.eq(slider.selectedIndex ).addClass('is-selected');

	}

	function onSliderButtonClick(e) {
		var slider = e.data.slider;
		var index = $(this).index();
		slider.flickity('select', index);
	}

})(jQuery, document, window);